import DynamicPage, { getServerSideProps } from './[...dynamic-page]';

// ts-prune-ignore-next
export { getServerSideProps };
export default DynamicPage;
